<template>
  <v-container>
    <v-repeat-load-group-dialog v-if="loadToRepeat"
                                v-model="showRepeatLoadDialog"
                                :loadGroupId="loadToRepeat.humanId"
                                :sponsor="loadGroupSponsorName(loadToRepeat)"
                                :origin="loadToRepeat.loadGroup.details | originName"
                                :destination="loadToRepeat.loadGroup.details | destinationName"
                                :count="loadToRepeat.loadCount || 1"
                                :isMobile="isMobile"
                                :loading="loadingBtn"
                                :company="company"
                                :load-group="loadToRepeat.loadGroup"
                                @cancel="closeRepeatLoadDialog"
                                @newLoad="closeRepeatLoadDialog">
    </v-repeat-load-group-dialog>

    <schedule-load-calendar-dialog
      v-if="selectedLoad"
      v-model="showLoadDialog"
      :load="selectedLoad"
      :company-id="storeCompanyId"
      @repeat="repeatLoad($event)">
    </schedule-load-calendar-dialog>
    <v-toolbar>
      <v-icon color="primary" class="pr-4">sync</v-icon>
      <v-layout column>
        <v-toolbar-title>
          Weekly Recurring Load Groups
        </v-toolbar-title>
        <v-list-tile-sub-title class="font-weight-light font-italic">
          {{ $t('site-title.brief') }} adds these load groups to your planner every week based on the repeat loads' schedule
        </v-list-tile-sub-title>
      </v-layout>
    </v-toolbar>
    <v-card>
    <v-sheet height="500">
    <v-calendar
      ref="calendar"
      :start="recurringLoadScheduleStart"
      color="primary"
      type="week"
      show-month-on-first
      :weekdays="[1, 2, 3, 4, 5, 6, 0]"
    >

      <template slot="dayBody" slot-scope="{ date, timeToY, minutesToPixels }">
        <template v-for="(event, idx) in loadsByDate[date]">
          <!-- timed events -->
          <div
            v-if="event.pendingSchedule.localPickupTime"
            :key="`recurring-load-schedule-${idx}`"
            :style="{ top: timeToY(event.pendingSchedule.localPickupTime) + 'px', height: minutesToPixels(30) + 'px' }"
            class="my-event with-time"
            @click="open(event)"
            v-html="event.pendingSchedule.title"
          ></div>
          <div
            :style="{ top: timeToY(event.pendingSchedule.localPickupTime) + 'px', height: minutesToPixels(30) + 'px' }"
            v-else>What the H is wrong here</div>
        </template>
      </template>

    </v-calendar>
    </v-sheet>
    </v-card>  </v-container>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import Vue2Filters from 'vue2-filters';

import VRepeatLoadGroupDialog from '@/components/RepeatLoadGroupDialog';
import loadGroupMixin from '@/mixins/loadGroupMixin';
import companySectionMixin from '@/mixins/companySectionMixin';
import companyNamesMixin from '@/mixins/companyNames';
import ScheduleLoadCalendarDialog from './dialogs/ScheculeLoadCalendarDialog';


export default {
  name: 'VRecurringLoadsSchedule',
  components: {
    ScheduleLoadCalendarDialog,
    VRepeatLoadGroupDialog,
  },
  mixins: [
    companySectionMixin,
    loadGroupMixin,
    companyNamesMixin,
    Vue2Filters.mixin,
  ],
  data() {
    return {
      selectedLoad: null,
      loadToRepeat: null,
      showLoadDialog: false,
      showRepeatLoadDialog: false,
      loadingBtn: false,
    };
  },
  computed: {
    ...mapGetters('repeatingLoadTemplates', {
      loadingLoadTemplates: 'loadingLoads',
      loadTemplatesTime: 'timestamp',
      loadTemplates: 'list',
      storeCompanyId: 'companyId',
    }),
    _() {
      return _;
    },
    loadTemplatesAccurateSince() {
      if (this.loadingLoadTemplates) {
        return 'Loading ...';
      }

      return `Updated ${this.$options.filters.formatTimeStamp(this.loadTemplatesTime)}`;
    },
    recurringLoadScheduleStartMoment() {
      return moment().add(1, 'week').isoWeekday(1);
    },
    recurringLoadScheduleStart() {
      return this.recurringLoadScheduleStartMoment.format('YYYY-MM-DD');
    },
    loadsByDate() {
      const start = this.recurringLoadScheduleStart;

      const eventMap = {};

      const events = _.chain(this.sponsoredLoadTemplates)
        .flatMap((t) => {
          const timezone = this.loadGroupPickupLocationGooglePlace(t).timezone;
          const sponsor = this.loadGroupSponsor(t);
          const nickname = t.nickname;

          const schedule = _.get(t, 'recurrenceSchedule.loadGroups', []);

          const flat = _.chain(schedule)
            .map(l => _.cloneDeep(l))
            .map((l, idx) => ({ sponsor, nickname, plusDays: idx, ...l }))
            .filter((l) => {

              const deets = _.get(l, 'details', []);
              return _.size(deets) > 0;
            })
            .flatMap((l) => {
              return _.chain(l.details)
                .map(d => ({
                  date: moment(start).add(l.plusDays, 'day').format('YYYY-MM-DD'),
                  loadCount: d.loadCount,
                  localPickupTime: d.scheduledPickupTime,
                  localTimezone: timezone,
                  title: t.nickname || _.get(sponsor, 'name', 'Loady Load'),
                }))
                .value();
            })
            .map(d => ({ pendingSchedule: d, ...t }))
            .value();

          return flat;
        })
        .sortBy(['pendingSchedule.date', 'pendingSchedule.localPickupTime'])
        .map((e) => {
          // eslint-disable-next-line no-return-assign
          (eventMap[e.pendingSchedule.date] = eventMap[e.pendingSchedule.date] || []).push(e);
          return e;
        })
        .value();

      return eventMap;
    },
    sponsoredLoadTemplates() {
      return this.loadTemplates.map((load) => {
        const loadGroup = this.loadGroupFor(load);
        this.sponsorLoadGroup(loadGroup);
        return load;
      });
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    open(load) {
      this.selectedLoad = load;
      this.showLoadDialog = true;
    },
    repeatLoad(load) {
      this.loadToRepeat = load;
      this.showLoadDialog = false;
      setTimeout(() => {
        this.showRepeatLoadDialog = true;
      }, 500);
    },
    closeRepeatLoadDialog() {
      this.showRepeatLoadDialog = false;
    },
    loadData() {

    },
  },
  mounted() {
    this.$refs.calendar.scrollToTime('06:00');
  },
};

</script>

<style lang="css" scoped>
  .my-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #1867c0;
    color: #ffffff;
    border: 1px solid #1867c0;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
    left: 4px;
    margin-right: 8px;
    position: relative;
  }

  .with-time {
     position: absolute;
     right: 4px;
     margin-right: 0px;
   }
</style>



// WEBPACK FOOTER //
// src/pages/Companies/Loads/components/RecurringLoadsSchedule.vue